








import { Vue, Prop, Component, Provide } from 'vue-property-decorator';
import { Validable } from "./Validable";
import { RulesRunner } from "../private/FormSupport";

@Component
export default class AbcForm extends Vue implements Validable {
    @Prop({ type: Boolean }) value!: boolean;

    private fields!: { [key: string]: RulesRunner };    // Uninitialized so it's not reactive
    private status: { [key: string]: boolean } = {};

    @Provide("notifyForm")
    private notifyForm(id: string, fld?: RulesRunner) {
        if (!fld) {
            delete this.fields[id];
            delete this.status[id];
        } else {
            this.fields[id] = fld;
        }
    }

    @Provide("onFieldError")
    private onFieldError(id: string, on: boolean) {
        if (this.status[id] && !on) {
            Vue.delete(this.status, id);
        } else if (on) {
            Vue.set(this.status, id, on);
        }

        const err = this.computeErrorStatus();
        if (err == this.value) {
            this.$emit("input", !err);
        }
    }

    public created() {
        this.fields = {};
    }

    private computeErrorStatus(): boolean {
        return Object.keys(this.status).some((k) => !!this.status[k]);
    }

    public validate(): boolean {
        Object.keys(this.fields).forEach((k) => this.fields[k].runRules());
        return !this.computeErrorStatus();
    }

}
